import { useMemo } from 'react';
import { orderBoards } from '../lib/boards';
import { useSession } from '../store/session';
import { useSettings } from '../store/settings';
import type { BoardInfo } from '../sync/api';

/** The user's boards in their own order. */
export function useOrderedBoards(): BoardInfo[] {
  const boards = useSession((s) => s.boards);
  const order = useSettings((s) => s.boardOrder);
  return useMemo(() => orderBoards(boards, order), [boards, order]);
}
